import requests from './Setup'
import membershipsStore from 'stores/membershipsStore'

const RESOURCE = `/Settings`

export type RegionalSettings = {
  DateFormat: 'dd/MM/yyyy' | 'MM/dd/yyyy' | 'yyyy/MM/dd'
  TimeZoneId: string
}

export type TimeZoneOption = {
  Id: string
  DisplayName: string
  BaseUtcOffset: string
}

const Settings = {
  changeCorrelativeWithholding: (newCorrelative: number) =>
    requests.get(`${membershipsStore.serviceUrl + RESOURCE}/ChangeCorrelativeWithholding/${newCorrelative}`).then(response => {
      if (response && response.status === 200) return response.data
    }),
  getFiscalAlerts: () =>
    requests.get(`${membershipsStore.serviceUrl + RESOURCE}/FiscalAlerts`).then(r => r.data),
  updateFiscalAlerts: (payload: {
    Enabled: boolean
    Email?: string | null
    WhatsAppNumber?: string | null
    TelegramChatId?: string | null
  }) =>
    requests.put(`${membershipsStore.serviceUrl + RESOURCE}/FiscalAlerts`, payload).then(r => r.data),
  getRegional: (): Promise<RegionalSettings> =>
    requests.get(`${membershipsStore.serviceUrl + RESOURCE}/Regional`).then(r => r.data),
  updateRegional: (payload: RegionalSettings): Promise<RegionalSettings> =>
    requests.put(`${membershipsStore.serviceUrl + RESOURCE}/Regional`, payload).then(r => r.data),
  getTimeZones: (): Promise<TimeZoneOption[]> =>
    requests.get(`${membershipsStore.serviceUrl + RESOURCE}/TimeZones`).then(r => r.data),
}

export default Settings 